import React, { useState, useMemo } from 'react';
import {
  Menu,
  MenuItem,
  Icon,
  Text,
  Tag,
  Collapse,
  Intent
} from '@blueprintjs/core';
import './settings.css';

const SettingsSidebar = ({
  categories,
  activeItem,
  onSelect,
}) => {
  const initialState = useMemo(() => {
    const expanded = {};
    categories.forEach(section => {
      expanded[section.id] = section.defaultExpanded ?? true;
    });
    return expanded;
  }, [categories]);

  const [expandedSections, setExpandedSections] = useState(initialState);

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  const handleSelect = (itemId) => {
    if (onSelect) {
      onSelect(itemId);
    }
  };

  const renderMenuItem = (item) => {
    const isActive = item.id === activeItem;

    return (
      <MenuItem
        key={item.id}
        icon={<Icon icon={item.icon} size={16} />}
        text={
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text className="settings-sidebar-panel__item-label">
              {item.label}
            </Text>
            {item.description && (
              <Text className="settings-sidebar-panel__item-desc">
                {item.description}
              </Text>
            )}
          </div>
        }
        onClick={() => handleSelect(item.id)}
        className={`settings-sidebar-menu-item${isActive ? ' settings-sidebar-menu-item--active' : ''}`}
      />
    );
  };

  const renderSection = (section) => {
    const isExpanded = expandedSections[section.id];

    return (
      <div key={section.id} className="settings-sidebar-panel__section">
        <div
          className="settings-sidebar-panel__section-header"
          onClick={() => toggleSection(section.id)}
        >
          <div className="settings-sidebar-panel__section-header-left">
            <Icon icon={section.icon} size={14} className="settings-sidebar-panel__accent-icon" />
            <Text className="settings-sidebar-panel__section-title">
              {section.title}
            </Text>
            <Tag minimal round intent={Intent.PRIMARY}>
              {section.items.length}
            </Tag>
          </div>
          <Icon
            icon={isExpanded ? 'chevron-up' : 'chevron-down'}
            size={12}
            className="settings-sidebar-panel__chevron"
          />
        </div>
        <Collapse isOpen={isExpanded}>
          <Menu className="settings-sidebar-panel__menu">
            {section.items.map(renderMenuItem)}
          </Menu>
        </Collapse>
      </div>
    );
  };

  return (
    <div className="settings-sidebar-panel">
      <div className="settings-sidebar-panel__header">
        <div className="settings-sidebar-panel__header-row">
          <Icon icon="cog" size={24} className="settings-sidebar-panel__accent-icon" />
          <div>
            <Text className="settings-sidebar-panel__title">
              Settings
            </Text>
            <Text className="settings-sidebar-panel__subtitle">
              Manage your preferences
            </Text>
          </div>
        </div>
      </div>

      {categories.map(renderSection)}
    </div>
  );
};

export default SettingsSidebar;
